module.exports = __webpack_public_path__ + "static/media/logo-comt@2x.c55cca35.png";